import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Rocket } from "lucide-react";
import { useEvent } from "@/context/EventContext";

const STAGES = ["Fotoğraf analiz ediliyor…", "Yüz ve kıyafet detayları çıkarılıyor…", "Karikatür çiziliyor…", "Yıldız parıltıları ekleniyor…", "Son dokunuşlar…"];

export const Generating = () => {
  const { event } = useEvent();
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((x) => Math.min(x + 1, STAGES.length - 1)), 3200);
    return () => clearInterval(t);
  }, []);
  return (
    <section className="relative flex w-full max-w-md flex-col items-center py-10 text-center" data-testid="generating-screen">
      <div className="pointer-events-none absolute inset-0">
        {Array.from({ length: 18 }).map((_, k) => (
          <span key={`gen-star-${k}`} className="star" style={{ left: `${(k * 41) % 100}%`, top: `${(k * 67) % 100}%`, animationDelay: `${(k % 5) * 0.4}s` }} />
        ))}
      </div>
      <motion.div
        className="relative grid h-40 w-40 place-items-center rounded-full"
        style={{ background: "radial-gradient(circle, rgba(230,0,126,0.35), transparent 70%)" }}
        animate={{ scale: [1, 1.08, 1] }}
        transition={{ duration: 2.2, repeat: Infinity }}
      >
        <div className="rocket-float text-white drop-shadow-[0_0_24px_var(--accent)]">
          <Rocket size={72} strokeWidth={1.6} />
        </div>
        <span className="exhaust absolute left-1/2 top-[62%] h-10 w-3 -translate-x-1/2 rounded-full bg-gradient-to-b from-[var(--accent-soft)] to-transparent" />
      </motion.div>
      <p className="eyebrow mt-8">{event?.event_name}</p>
      <h2 className="font-display mt-3 text-xl font-extrabold sm:text-2xl" data-testid="generating-stage">{STAGES[i]}</h2>
      <p className="mt-2 text-sm text-slate-400">Genellikle 15–40 saniye sürer.</p>
      <div className="shimmer mt-6 h-1.5 w-56 overflow-hidden rounded-full bg-white/10">
        <motion.div className="h-full rounded-full bg-[var(--accent)]" initial={{ width: "8%" }} animate={{ width: `${20 + i * 18}%` }} transition={{ duration: 1.2 }} />
      </div>
    </section>
  );
};
